module.exports = __webpack_public_path__ + "img/project-4.dc0aa56b.jpg";